import { render, staticRenderFns } from "./PurchaseEdit_Total.vue?vue&type=template&id=6af034ca&"
import script from "./PurchaseEdit_Total.vue?vue&type=script&lang=js&"
export * from "./PurchaseEdit_Total.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports